<template>
    <div class="bg-sso page-otp">
        <LoadingSSO :isShow="loading" />
        <div class="btn_back" @click="$router.go(-1)">
            <img src="../../assets/icon/btn_back.svg" alt="" />
        </div>
        <div class="wrapper_logo_sso">
            <img src="../../assets/ssoauth/iconsso.svg" />
        </div>
        <div class="wrapper_card_sso">
            <div class="title">
                รหัสยืนยันตัวตน OTP
            </div>

            <div class="text-otp">
                ระบบได้ทำการส่งรหัส OTP ไปที่เบอร์
                <div>{{ formatted(data.contactNo) }}</div>
            </div>
            <div class="text-otp-ref">รหัสอ้างอิง : {{ refcode }}</div>
            <div class="text-center">
                <label for="input-otp" class="input-otp">
                    <div class="d-flex justify-content-center">
                        <div
                            class="box-input-otp"
                            :class="{ error: !isExpireTime }"
                        >
                            {{ otp[0] }}
                        </div>
                        <div
                            class="box-input-otp"
                            :class="{ error: !isExpireTime }"
                        >
                            {{ otp[1] }}
                        </div>
                        <div
                            class="box-input-otp"
                            :class="{ error: !isExpireTime }"
                        >
                            {{ otp[2] }}
                        </div>
                        <div
                            class="box-input-otp"
                            :class="{ error: !isExpireTime }"
                        >
                            {{ otp[3] }}
                        </div>
                        <div
                            class="box-input-otp"
                            :class="{ error: !isExpireTime }"
                        >
                            {{ otp[4] }}
                        </div>
                        <div
                            class="box-input-otp"
                            :class="{ error: !isExpireTime }"
                        >
                            {{ otp[5] }}
                        </div>
                    </div>
                </label>
            </div>
            <input
                type="tel"
                id="input-otp"
                class="input-otp-dummy"
                maxlength="6"
                v-model="otp"
                @input="onOtpChange()"
            />
            <div class="err-otp" v-if="isErrorMessage">
                {{ errorMessage }}
            </div>
            <div class="wrapper_btn_otp">
                <button class="button-account" @click="onSubmitOtp()">
                    ถัดไป
                </button>
            </div>
            <div class="resend" v-if="isExpireTime">
                <span>ส่งรหัส OTP อีกครั้ง ในเวลา</span>
                <span class="timer">
                    {{ timeHelper.displayTime }}
                </span>
            </div>
            <div v-if="!isExpireTime" class="resend">
                <a
                    id="otp-resend-btn"
                    :class="{ expired: !isExpireTime }"
                    @click="resendOtp()"
                >
                    ส่งรหัส OTP อีกครั้ง<br />
                </a>
                <span>หากไม่ได้รับ SMS สามารถโทรติดต่อ 02-657-8625</span>
            </div>
        </div>
    </div>
</template>

<script>
import Locale from "@/helper/locale/locale.js";
import TimerHelper from "@/helper/TimerHelper.js";
//service
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

import LoadingSSO from "@/components/LoadingSSO/Loading.vue";
/**
 * ! This file copy form Food Hunt
 * @property {String} modalId (reqquired)
 */
export default {
    name: "OtpModal",
    components: {
        LoadingSSO
    },
    props: {
        data: Object
    },
    mixins: [ErrorApiMixin],
    data: function() {
        return {
            loading: false,
            lbl: Locale.getLbl(),

            tel: "",
            otp: "",
            refcode: "",
            channel: "ssoregis",

            resend: false,
            otpData: {},

            finalData: "",

            timeHelper: new TimerHelper(),
            isExpireTime: false,

            errorMessage: "",
            isErrorMessage: false
        };
    },
    created: function() {
        // correct expried date
        // const currentTime = Math.floor(Date.now() / 1000)
        // const expireIn = this.data.expiredate - currentTime;
        // this.timeHelper.initialTimer(expireIn, null, false, false);

        // fixed 5 minutes
        document.body.classList.add("body-sso");
        this.timeHelper.initialTimer(60 * 5, null, false, false);
    },
    mounted: function() {
        this.loading = true;
        this.startOtp();
        setTimeout(() => {
            this.loading = false;
        }, 500);
    },
    methods: {
        formatted: function(input) {
            var n1, n2, n3;
            if (input) {
                n1 = input.substr(0, 3);
                n2 = input.substr(3, 3);
                n3 = input.substr(6);
                input = n1 + "-" + n2 + "-" + n3;
            }
            return input;
        },
        clearOtp: function() {
            this.otp = "";
        },
        //#region otp
        startOtp: async function() {
            this.isExpireTime = false;
            if (this.resend === false) {
                this.tel = this.data.contactNo;
                this.refcode = this.data.refcode;
            } else {
                this.timeHelper.stopTimer();
                this.timeHelper.resetTimer();
            }

            this.otp = "";

            this.isErrorMessage = false;

            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });
            this.isExpireTime = true;
        },
        cancelOtp: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();

            this.$store.commit("setDupphone", {
                isdup: false,
                message: ""
            });
        },
        onOtpChange: function() {
            this.otp = this.otp.replace(/\D/g, "");
        },
        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = false;
        },
        onSubmitOtp: async function() {
            if (this.validateOtp()) {
                this.loading = true;
                await this.apiValidateOtp();
            }
            if (this.finalData) {
                this.$router.push({
                    name: "register",
                    params: { data: this.finalData }
                });
            }
        },
        apiValidateOtp: async function() {
            console.log(this.refcode);
            return new Promise((resolve, reject) => {
                BzbsOtp.validateNestleOtp(
                    this.tel,
                    this.refcode,
                    this.otp
                ).subscribe(
                    data => {
                        console.log(data);
                        if (!data.data) {
                            data.data = { ContactNumber: this.tel };
                        }
                        this.finalData = data;
                        resolve(true);
                    },
                    err => {
                        this.isErrorMessage = true;
                        this.errorMessage = err.message;
                        if (err.message === "รหัส OTP ไม่ถูกต้อง") {
                            this.errorMessage =
                                "รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง";
                        }
                        this.isExpireTime = false;
                        this.loading = false;
                        reject(false);
                    }
                );
            });
        },
        validateOtp: function() {
            if (this.otp.length != 6) {
                this.errorMessage = this.lbl.otp.otpLength;
                if (this.otp == "") {
                    this.errorMessage = this.lbl.otp.requireInput;
                }
                this.isErrorMessage = true;
                return false;
            }

            return true;
        },
        resendOtp: async function() {
            this.isExpireTime = false;
            this.isErrorMessage = false;

            await this.clickResend();
            this.resend = true;
            await this.startOtp();
        },
        clickResend: async function() {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe(
                    data => {
                        this.otpData = data;
                        this.refcode = this.otpData.refcode;
                        resolve(true);
                    },
                    err => {
                        // this.controller.loadingModal.hide();
                        // if (err.id == 2078) {
                        //     this.controller.alertModal
                        //         .clearText()
                        //         .setMsg(err.message)
                        //         .show();
                        //     this.controller.alertModal.onClickOk(() => {
                        //         this.controller.sendCallbackError(err);
                        //     });
                        // } else {
                        //     this.errorResponse(err);
                        // }
                        console.log(err);
                        reject(false);
                    }
                );
            });
        }
    }
};
</script>
<style lang="scss">
.body-sso {
    background: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
@import "../../components/Modal/Authen/OTP/OtpModal.scss";
@import "@/style/sso.scss";
</style>
